require('./ctxNavigationBar.style.scss');

class CtxNavigationBarController {
    constructor() {
    }
}

const ctxNavigationBarComponent = {
    controller: CtxNavigationBarController,
    scope: {},
    template: require('./ctxNavigationBar.template.html'),
    transclude: {
        'leftSlot': '?leftNav',
        'rightSlot': 'mainNav'
    }
};

CtxNavigationBarController.$inject = [];

module.exports = ctxNavigationBarComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxNavigationBar/ctxNavigationBar.component.js